export const SET_IS_MOBILE = "SET_IS_MOBILE";

const isMobile = (state = window.innerWidth <= 768, action) => {
  switch (action.type) {
    case SET_IS_MOBILE:
      return action.payload;

    default:
      return state;
  }
};

export default isMobile;
